export const jasonFairImage =
  "https://firebasestorage.googleapis.com/v0/b/pick-a-class.appspot.com/o/Jason-DNA-bubbles-green-min.png?alt=media&token=7a4c9c86-d4f6-4676-ab0b-04bcc53cf6d3&_gl=1*x4xffj*_ga*OTIxMzQyMTU0LjE2OTc1Nzc2MTY.*_ga_CW55HF8NVT*MTY5NzU3NzYxNi4xLjEuMTY5NzU3NzgzMi40MC4wLjA.";
export const kelleyHowardImage =
  "https://media.graphassets.com/output=format:jpg/resize=height:800,fit:max/oducKp4PROiBUOFP190Z";
export const kurtGrevesImage =
  "https://media.graphassets.com/output=format:jpg/resize=height:800,fit:max/1vbhIrrKROtacNKuSMr0";

export const seanBollingerImage =
  "https://firebasestorage.googleapis.com/v0/b/pick-a-class.appspot.com/o/Sean-DNA-bubbles-min.png?alt=media&token=34674e54-4158-4803-bdcb-ce3e947df400&_gl=1*169oeyb*_ga*OTIxMzQyMTU0LjE2OTc1Nzc2MTY.*_ga_CW55HF8NVT*MTY5NzU3NzYxNi4xLjEuMTY5NzU3NzcyOS4zOC4wLjA.";
export const adamMarinerImage =
  "https://firebasestorage.googleapis.com/v0/b/pick-a-class.appspot.com/o/Adam-DNA-bubbles-min.png?alt=media&token=a1b3a88a-0131-4989-97ed-08915461da3f&_gl=1*p574ny*_ga*OTIxMzQyMTU0LjE2OTc1Nzc2MTY.*_ga_CW55HF8NVT*MTY5NzU3NzYxNi4xLjEuMTY5NzU3Nzg0NS4yNy4wLjA.";
export const dvBioNumber = "480-382 3009";
export const dvBioEmail = "info@digividbio.com";
export const dvBioAddressL1 = "6619 N. Scottsdale Rd.";
export const dvBioAddressL2 = "Suite D";
export const dvBioAddressL3 = "Scottsdale, AZ 85250";
export const dvBioKelleyHowardEmail = "kelley@digividbio.com";
export const dvBioFacebook = "https://www.facebook.com/DigiVidBIO/";
export const dvBioTwitter = "https://twitter.com/DigiVidBIO";
export const dvBioInstagram = "https://www.instagram.com/DigiVidBIO/";
export const dvBioLinkedIn = "https://www.linkedin.com/company/DigiVidBIO/";
